import React from 'react';

function Idle() {
    return <div>Idle</div>;
}

export default Idle;
